// Every piece of content the site renders, in one request.
//
// Privacy is applied here rather than in the browser so hidden projects are not
// in the response at all. Note this hides them from the site, not from the API —
// the dataset is public, so treat it as visibility control, not access control.

const PROJECT_FIELDS = `
  "slug": slug.current,
  title,
  description,
  "categories": categories[]->title,
  client,
  role,
  tools,
  scope,
  banner,
  images[]{ ..., _key },
  liveUrl,
  sourceUrl,
  isPrivate
`;

// Projects and client logos share one rule: visible unless private, and a
// private one shows only when its own toggle AND the site-wide switch are on.
// The inner showPrivate belongs to siteSettings, the outer to the document.
const VISIBLE = `
  isPrivate != true ||
  (showPrivate == true && count(*[_id == "siteSettings" && showPrivate == true]) > 0)
`;

export const CONTENT_QUERY = `{
  "settings": *[_id == "siteSettings"][0]{
    navLinks[]{ _key, label, href },
    navCTA,
    socials[]{ _key, label, href },
    available,
    availabilityLabel,
    siteTitle,
    siteDescription,
    siteUrl,
    ogImage,
    author,
    jobTitle,
    locality,
    country
  },
  "home": *[_id == "homePage"][0],
  "workPage": *[_id == "workPage"][0],
  "notFoundPage": *[_id == "notFoundPage"][0],
  "contact": *[_id == "contactSection"][0],
  "projects": *[_type == "project" && (${VISIBLE})] | order(title asc){${PROJECT_FIELDS}},
  "clients": *[_type == "client" && (${VISIBLE})] | order(name asc){
    _id,
    name,
    logoDark,
    logoLight
  },
  // Marquee order, drag-sorted on the home page. Anything not listed still
  // renders — it just falls to the end.
  "clientOrder": *[_id == "homePage"][0].clientLogos[]._ref,
  "featuredSlugs": *[_id == "homePage"][0].featuredProjects[]->slug.current,
  // The filter chips on /work. Each gathers several categories, and a category
  // may sit in more than one chip.
  "filterGroups": *[_id == "workPage"][0].filterGroups[]->{
    _id,
    label,
    "cats": categories[]->title
  }
}`;
